export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/78489dd5fe22b2b724f99f5861a7cee7.svg";